import React, { useEffect, useState } from "react";
import "./AddStudentsToClassForm.css";
import TextFieldInput from "../../../Atoms/Inputs/TextField/TextFieldInput";
import PrimaryButton from "../../../Atoms/Buttons/Primary/PrimaryButton";
import { Autocomplete } from "@mui/material";
import useSave from "../../../../Hooks/useSave";
import { classesURL } from "../../../../Hooks/URL";
import { Formik } from "formik";
import useFetch from "../../../../Hooks/useFetch";
import { useNavigate, useParams } from "react-router-dom";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import useFetchWhen from "../../../../Hooks/useFetchWhen";
import { PulseLoader } from "react-spinners";
import Filter from "../../../Molecules/Filter/Filter";

function AddStudentsToClassForm({
  Edit = false,
  url,
  setOpen,
  setStudents,
  page,
  search,
  classData,
  loading,
  contextData,
}) {
  const navigate = useNavigate();
  const [newObject, setNewObject] = useState({});
  const [stud, setstud] = useState([]);
  const [error, setError] = useState("");
  const [goSave, setGoSave] = useState(false);
  const [filterParams, setFilterParams] = useState("");
  const { saveState, loading: addLoading } = useSave({
    url: `${classesURL}/${classData?.id}/students`,
    goSave,
    setGoSave,
    newObject,
  });

  // Build URL with filter parameters
  const baseURL = `${classesURL}/${classData?.id}/students/toEnroll`;
  const studentsURL = filterParams
    ? `${baseURL}${
        filterParams.startsWith("&")
          ? filterParams.replace("&", "?")
          : filterParams
      }`
    : baseURL;

  const {
    data: studentsList,
    loading: studentsLoading,
    error: studentsError,
  } = useFetchWhen(studentsURL, classData?.id);

  useEffect(() => {
    if (saveState.dataRes.status == "success") {
      navigate(`/classes/${classData?.id}`);
    }
  }, [saveState, navigate]);

  useEffect(() => {
    if (stud.length) {
      setError("");
    }
  }, [stud]);

  // Get available students (not enrolled)
  const availableStudents = (studentsList?.data || []).filter(
    (student) => !student?.enrolled
  );

  // Select all available students
  const handleSelectAll = () => {
    setstud(availableStudents);
  };

  // Clear all selected students
  const handleClearAll = () => {
    setstud([]);
  };

  return (
    <div className="CourseSmallFormWrapper">
      <Formik
        initialValues={{
          students: [],
        }}
        onSubmit={(values) => {
          if (stud.length) {
            setNewObject({ studentIds: stud?.map((item) => item?.id) });
            setGoSave(true);
          } else {
            setError("Add at least one student !!");
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="ClassFormContainer">
              <div
                className="studentActionButtons"
                style={{ justifyContent: "flex-start", marginBottom: "10px" }}
              >
                <button
                  type="button"
                  onClick={handleSelectAll}
                  disabled={availableStudents.length === 0}
                  className="studentActionButton selectAll"
                >
                  Select All
                </button>
                <button
                  type="button"
                  onClick={handleClearAll}
                  disabled={stud.length === 0}
                  className="studentActionButton clearAll"
                >
                  Clear All
                </button>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "100%" }}>
                  <Autocomplete
                    multiple
                    options={studentsList?.data || []}
                    getOptionDisabled={(option) => option?.enrolled}
                    getOptionLabel={(option) =>
                      !option?.enrolled
                        ? option?.name
                        : `${option?.name} (Already Enrolled)`
                    }
                    filterSelectedOptions
                    disableCloseOnSelect
                    name={"students"}
                    className="chooseStudents"
                    value={stud}
                    onChange={(e, newValue) => setstud(newValue)}
                    loading={studentsLoading}
                    renderInput={(params) => (
                      <TextFieldInput
                        {...params}
                        label="Add Student"
                        placeholder="Students"
                        className={`Input`}
                        styles={{ width: "100%" }}
                        name={"students"}
                        Required={false}
                      />
                    )}
                  />
                  {error && <p className="error">{error}</p>}
                </div>

                <Filter
                  Gender={true}
                  Grades={true}
                  setFilter={setFilterParams}
                />
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                className="actionButton primary addButton"
                onClick={handleSubmit}
                disabled={addLoading}
              >
                {addLoading ? <PulseLoader color="white" size={8} /> : "Add"}
              </button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default AddStudentsToClassForm;
